import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "../features/HomeContainer/HomeSlice";
import servicesReducer from "../features/ServicesContainer/ServicesSlice";
import experiencesReducer from "../features/ExperiencesContainer/ExperiencesSlice";
import destinationsReducer from "../features/DestinationsContainer/DestinationsSlice";
import aboutReducer from "../features/AboutContainer/AboutSlice";
import quizReducer from "../features/QuizContainer/QuizSlice";
import floatingReducer from "../features/FloatingContainer/FloatingSlice";
import footerReducer from "../features/FooterContainer/FooterSlice";

const store = configureStore({
  reducer: {
    home: homeReducer,
    services: servicesReducer,
    experiences: experiencesReducer,
    destinations: destinationsReducer,
    about: aboutReducer,
    quiz: quizReducer,
    floating: floatingReducer,
    footer: footerReducer,
  },
});

export default store;
